import React from "react";
import _ from "lodash";

import SweetAlert from "react-bootstrap-sweetalert";
import Form from "react-jsonschema-form";
import {withApollo} from "react-apollo";
import withStyles from "material-ui/styles/withStyles";

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import Button from "components/CustomButtons/Button";
import {schema_default, uiSchema} from "../constants";
import {createUsers } from "../graph";

//material-ui core
import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";


class GenerateUsersModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          schema: schema_default,
          uiSchema: uiSchema,
          groupDefault: 0,
          formData: {}
        }
    }
    
    /*
        groupDefault values
        0 = New Group
        1 = Existing Group
    */
    componentDidUpdate(prevProps, prevState){
        // If switched from New Group to Existing Group trigger this update
        if (prevState.groupDefault === 0 && this.state.groupDefault === 1){
            const schema = schema_default;
            let group_name = schema.dependencies.group.oneOf[1].properties.existing_group;
            let enums = [];
            let enumNames = [];
           
            // Add enums on existing group select
            if(!_.isEmpty(this.props.getProjectGroups.getProjectGroups)){
                this.props.getProjectGroups.getProjectGroups.map((group, index) => {
                    enums.push(parseInt(group.groupId));
                    enumNames.push(`${group.groupId}-${group.name}`);
                });
            }
            else{
                enums.push(-1);
                enumNames.push("None");
            }

            group_name.enum = enums;
            group_name.enumNames = enumNames;
            group_name.default = enums[0];

            this.setState({
                schema: schema,
                uiSchema: uiSchema
            });
            
        }
    }

    onFormSubmit(form) {
        const data = form.formData;
        this.props.createUsers({
            variables: {
              pid: this.props.projectId,
              username: data.username,
              userCount: data.usercount,
              userType: data.userType,
              groupName: (data.group === 0) ? data.new_group : data.existing_group,
              groupType: data.group
            }
        }).then((data) => {
            alert('Users created successfully');
            this.props.onUsersModalClose();
        });
    }
    onFormChange(form){
        const formData = form.formData;

        // Change group status if it changed
        if (formData.group === this.state.group){
            // nothing here
        }
        else{
            this.setState({
                groupDefault: formData.group
            });  
        }
        this.setState({
            formData: formData
        })
    }

    onFormValidate(formData, errors) {
        if (formData.usercount <= 0)
            errors.usercount.addError("User count should not be equal or less than 0");
        // Add Error if user chose non existing group 
        if (formData.existing_group === -1 && formData.group === 1)
            errors.existing_group.addError("Existing group should not be None (If no group is present, choose New Group Option)")
        
        return errors;
    }

    render() {
        const { schema, uiSchema, formData } = this.state;
        return (
            <Dialog
                open={true}
                title="Generate Users"
                onClose={() => this.props.onUsersModalClose()}
                aria-labelledby="gen-users-modal-title"
                aria-describedby="gen-users-modal-description"
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle 
                    id="gen-users-modal-title"
                >
                    Add Entry
                </DialogTitle>
                <DialogContent
                    id="gen-users-modal-description"
                >
                    <GridContainer>
                        <ItemGrid xs={12}>
                            <Form
                                schema={schema}
                                uiSchema={uiSchema}
                                method="post"
                                onSubmit={this.onFormSubmit.bind(this)}
                                validate={this.onFormValidate.bind(this)}
                                onChange={this.onFormChange.bind(this)}
                                formData={formData}
                            >
                            <Button color="rose" type="submit">Generate</Button>
                            </Form>
                        </ItemGrid>
                    </GridContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.props.onUsersModalClose()}>Close</Button>
                </DialogActions>
            </Dialog>
        )
    }

}

export default withStyles(sweetAlertStyle)((createUsers)(withApollo(GenerateUsersModal)))


// WEBPACK FOOTER //
// ./src/views/users/components/GenerateUsersModal.js